// 容器尺寸常量
export const CONTAINER_SIZE = 256;
// 最小缩放比例常量
export const MIN_SCALE = 100;
// 最大缩放比例常量
export const MAX_SCALE = 300;
// 缩放步长常量
export const STEP = 10;
